export default "__VITE_ASSET__P2FgsDO7__"